/**
 * Bilingual name overlay for corpus entities.
 *
 * The raw corpus has only Latin names. For the demo, a small hand-curated
 * Persian mapping keeps <EntityName> bilingual without a backend change.
 * Swap this for a real `name_fa` column when the data model supports it.
 */
export const ENTITY_NAME_FA: Record<string, string> = {
  'Trita Parsi': 'تریتا پارسی',
  'Rouzbeh Parsi': 'روزبه پارسی',
  'Javad Zarif': 'محمدجواد ظریف',
  'Mostafa Zahrani': 'مصطفی زهرانی',
  'Saeed Khatibzadeh': 'سعید خطیب‌زاده',
  'Bob Ney': 'باب نی',
  'Robert Malley': 'رابرت مالی',
  'Ariane Tabatabai': 'آریان طباطبایی',
  'Ali Vaez': 'علی واعظ',
  'Dina Esfandiary': 'دینا اسفندیاری',
  'Francis Najafi': 'فرانسیس نجفی',
  'Siamak Namazi': 'سیامک نمازی',
  Hooshang: 'هوشنگ',
  'Hooshang Amirahmadi': 'هوشنگ امیراحمدی',
  'Jamshid Alaghband': 'جمشید علاقبند',
  'Jake Sullivan': 'جیک سالیوان',
  'Brett McGurk': 'برت مک‌گرک',
  'Colin Kahl': 'کالین کال',
  NIAC: 'شورای ملی ایرانیان آمریکا',
  'Quincy Institute': 'مؤسسه کوئینسی',
  'Iran Experts Initiative': 'ابتکار کارشناسان ایران',
  IRGC: 'سپاه پاسداران انقلاب اسلامی',
  'U.S. State Department': 'وزارت خارجه آمریکا',
  'U.S. Pentagon': 'پنتاگون',
  'White House': 'کاخ سفید',
  FBI: 'اف‌بی‌آی',
  'Iranian Foreign Ministry': 'وزارت خارجه جمهوری اسلامی',
  'Iran UN Mission': 'نمایندگی ایران در سازمان ملل',
  IPIS: 'مؤسسه مطالعات سیاسی و بین‌المللی',
  'Swedish UN Mission': 'نمایندگی سوئد در سازمان ملل',
  'Swedish Intelligence': 'سرویس اطلاعات سوئد',
  FARA: 'قانون ثبت عوامل خارجی',
  LDA: 'قانون افشای لابی',
  'IRS Form 990': 'فرم ۹۹۰ مالیاتی',
  'Open Society Foundations': 'بنیادهای جامعه باز',
  'Ploughshares Fund': 'صندوق پلاشیرز',
  'Alavi Foundation': 'بنیاد علوی',
};

export function getNameFa(name: string | undefined): string | undefined {
  if (!name) return undefined;
  return ENTITY_NAME_FA[name];
}
